// components/tabs/DataTab.jsx
// 数据矩阵 — 完整表格 + 选中行高亮 + 自动滚动

import { useSolPred } from '../../hooks/useSolPredStore';
import { PHASE_COLORS } from '../../data/systems';

export default function DataTab() {
  const {
    selectedSystem, temperature,
    dataPoints, phaseList,
    selectedPoint, setSelectedPoint, selectedRowRef,
  } = useSolPred();

  return (
    <div className="canvas-card full fade-in">
      <div className="canvas-header">
        <div>
          <div className="canvas-title">数据矩阵 · Data Matrix</div>
          <div className="canvas-subtitle">
            {dataPoints.length} 条记录 · T = {temperature}°C 等温截面
          </div>
        </div>
        <div className="canvas-tools">
          <button className="tool-btn">导出 CSV</button>
          <button className="tool-btn">导出 JSON</button>
        </div>
      </div>
      <div className="data-table-wrap">
        <table className="data-table">
          <thead>
            <tr>
              <th>#</th>
              <th>w₁ ({selectedSystem.components[0]})</th>
              <th>w₂ ({selectedSystem.components[1]})</th>
              <th>w_H₂O</th>
              <th>T (°C)</th>
              <th>固相</th>
              <th>不确定度 σ</th>
              <th>来源</th>
            </tr>
          </thead>
          <tbody>
            {dataPoints.map((p, i) => {
              const pIdx = phaseList.indexOf(p.solidPhase);
              const col = PHASE_COLORS[pIdx % PHASE_COLORS.length];
              const isSel = selectedPoint?.id === p.id;
              return (
                <tr
                  key={p.id}
                  ref={isSel ? selectedRowRef : null}
                  className={isSel ? 'row-selected' : ''}
                  onClick={() => setSelectedPoint({ kind: 'experimental', ...p })}
                  style={{ cursor: 'pointer' }}
                >
                  <td style={{ color: 'var(--text-3)' }}>{isSel ? '▶' : i + 1}</td>
                  <td>{p.w1.toFixed(4)}</td>
                  <td>{p.w2.toFixed(4)}</td>
                  <td>{p.ww.toFixed(4)}</td>
                  <td>{p.temp}</td>
                  <td>
                    <span className="phase-tag" style={{
                      background: col + '1a',
                      color: col,
                      border: `1px solid ${col}33`,
                    }}>
                      {p.solidPhase}
                    </span>
                  </td>
                  <td style={{ color: 'var(--text-3)' }}>±{p.uncertainty}</td>
                  <td style={{
                    fontFamily: "'IBM Plex Sans',sans-serif",
                    color: 'var(--text-2)',
                  }}>{p.source}</td>
                </tr>
              );
            })}
          </tbody>
        </table>
      </div>
    </div>
  );
}
